import { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

export default function PageTransition({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation();
  const [phase, setPhase] = useState<"idle" | "fading-out" | "hidden" | "fading-in">("idle");

  const runTransition = useCallback(() => {
    setPhase("fading-out");
    setTimeout(() => {
      setPhase("hidden");
      setTimeout(() => {
        setPhase("fading-in");
        setTimeout(() => {
          setPhase("idle");
        }, 50);
      }, 80);
    }, 180);
  }, []);

  useEffect(() => {
    const handler = () => {
      runTransition();
    };
    i18n.on("languageChanged", handler);
    return () => {
      i18n.off("languageChanged", handler);
    };
  }, [i18n, runTransition]);

  return (
    <div className="relative">
      {/* Main content */}
      <div
        className={`transition-opacity duration-[180ms] ease-in-out ${
          phase === "fading-out" || phase === "hidden"
            ? "opacity-0"
            : "opacity-100"
        }`}
      >
        {children}
      </div>

      {/* Flash overlay */}
      <div
        className={`fixed inset-0 z-[9999] pointer-events-none transition-opacity duration-[180ms] ease-in-out bg-background-50/60 ${
          phase === "fading-out" || phase === "fading-in"
            ? "opacity-100"
            : "opacity-0"
        }`}
      />
    </div>
  );
}